import { useDispatch } from 'react-redux';

import { push } from 'connected-react-router';
import { useAuth } from 'features/auth/auth-action-sign-in-out';
import { useAppSelector } from 'lib/store/rootReducer';
import { paths } from 'routes';
import { useAnalytics } from 'lib/hooks/use-analytics';

export function useSignOut() {
  const dispatch = useDispatch();
  const analytics = useAnalytics();
  const user = useAppSelector(state => state.auth.user);
  const auth = useAuth(dispatch);

  async function onClick() {
    await analytics.track('auth:sign-out:click');

    return auth.signOut.mutate(void 0, {
      onSuccess() {
        if (!user) return;
        dispatch(push(paths.signIn()));
      }
    });
  }

  return { onClick };
}
